import styled from 'styled-components';

interface MobileMenuContainerProps {
  isOpen: boolean;
}

export const MobileMenuContainer = styled.div<MobileMenuContainerProps>`
  position: fixed;
  top: 0;
  right: 0;
  width: 80%;
  max-width: 350px;
  height: 100vh;
  background-color: var(--primary-color);
  color: var(--light-text);
  z-index: 1000;
  transform: ${({ isOpen }) => isOpen ? 'translateX(0)' : 'translateX(100%)'};
  transition: transform 0.3s ease-in-out;
  box-shadow: -5px 0 15px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  overflow-y: auto;
`;

export const MobileMenuHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);

  h2 {
    margin: 0;
    font-size: 1.5rem;
  }
`;

export const CloseButton = styled.button`
  background: transparent;
  border: none;
  color: var(--light-text);
  font-size: 1.5rem;
  cursor: pointer;
  padding: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.3s ease;

  &:hover {
    color: var(--accent-color);
  }
`;

export const MobileNav = styled.ul`
  list-style: none;
  padding: 1.5rem;
  margin: 0;
`;

export const MobileNavItem = styled.li`
  margin-bottom: 1.5rem;

  a {
    color: var(--light-text);
    font-size: 1.2rem;
    font-weight: 500;
    display: block;
    padding: 0.5rem 0;
    transition: color 0.3s ease, transform 0.3s ease;

    &:hover {
      color: var(--accent-color);
      transform: translateX(5px);
    }
  }
`;